// Demo reviewer directory.
// Hard-coded for the assign-to-reviewer demo mock — no backend lookup.
// Mirrors the REVIEWERS list in scanflow-prototype/src/App.jsx.
export type Reviewer = {
  id: string;
  name: string;
  role: string;
};

export const REVIEWERS: readonly Reviewer[] = [
  { id: "chen", name: "Dr. Sarah Chen", role: "Attending · QA Reviewer" },
  { id: "torres", name: "Dr. Michael Torres", role: "Attending · QA Reviewer" },
  { id: "patel", name: "Dr. Priya Patel", role: "Attending · QA Reviewer" },
  { id: "kim", name: "Dr. Alex Kim", role: "Resident PGY-3" },
] as const;

export const findReviewer = (id: string | null | undefined): Reviewer | null =>
  REVIEWERS.find((r) => r.id === id) ?? null;
